import dayjs from 'dayjs'

/**
 * 处理各个表单信息
 * @fillInfoList 处理数组
 * @type 为谁处理
 */
export const disposeFillInInfoToObj = (fillInfoList, type) => {
    return fillInfoList.reduce((result, current) => {
        let { key, value } = current;
        switch(type) {
            case 'forCreateLive':
                switch(key) {
                    case 'startTime':
                        result[key] = value? new Date(value).getTime(): '';
                        break;
                    case 'courseDuration':
                        result[key] = ((value || "").split(":")).reduce((courseDurationResult, courseDurationArrInnerItem, courseDurationArrInnerIndex) => {
                            if (courseDurationArrInnerIndex === 0) {
                                courseDurationResult += Number(courseDurationArrInnerItem) * 60 * 60 * 1000;
                            } else if (courseDurationArrInnerIndex === 1) {
                                courseDurationResult += Number(courseDurationArrInnerItem) * 60 * 1000;
                            }
                            return courseDurationResult;
                        }, 0);
                        break;
                    default:
                        result[key] = value;
                        break;
                }
                break;
            default:
                result[key] = value;
                break;
        }
        return result;
    }, {});
}

/**
 * 清空各个表单信息
 * @fillInfoList 处理数组
 * @type 为谁处理
 */
export const resetFillInInfoListAnyOne = (fillInfoList, type) => {
    return fillInfoList.map(item => {
        switch(type) {
            case 'forCreateLive':
                let { key } = item;
                switch (key) {
                    case 'startTime':
                        item.dateValue = "";
                        item.timeValue = "";
                        item.value = "";
                        break;
                    default: 
                        item.value = "";
                        break;
                }
                break;
            default:
                item.value = "";
                break;
        }
        return item;
    })
}

// 获取随机数：
export const getRandom = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// 匹配枚举：
export const getNameTextForEnumeration = (options, value) => {
    let res = options.find(item => item.value == value);
    return (res && res.name)? res.name: '- -';
}

// 处理秒：
export const secondsFormat = s => {
    s = Math.floor(s);
    let hour = Math.floor( s / 3600);
    let minute = Math.floor( (s - hour * 3600) /60 );
    let second = s - hour * 3600 - minute * 60;
    return hour.toString().padStart(2,'0') + ":" + minute.toString().padStart(2,'0')  + ":" + second.toString().padStart(2,'0');
}

// 获取随机数2：
export const getRandomNumber = len => {
    let sum = 1;
    for (let i = 0; i < len - 1; i++) {
        sum *= 10;
    }
    return String(Math.floor(Math.random() * 10 * sum));
}

// 是否火狐：
export const isFirefox = () => {
    return navigator.userAgent.indexOf('Firefox') >= 0;
}

// 谷歌浏览器版本是否满足条件：
export const isCompatibleChrome = () => {
    let arr = navigator.userAgent.split(' '); 
    let chromeVersion = '';
    for(var i = 0; i < arr.length; i++) {
        if(/chrome/i.test(arr[i])) chromeVersion = arr[i];
    }
    let chromeVersionRes = 0;
    if(chromeVersion) {
        chromeVersionRes = Number(chromeVersion.split('/')[1].split('.')[0]);
    }
    if(chromeVersionRes > 72) {
        return true;
    } else {
        return false;
    }
}

// 是否ip格式：
export const isIP = ip => {
    var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    if (re.test(ip)) {
        if (Number(RegExp.$1) < 256 && Number(RegExp.$2) < 256 && Number(RegExp.$3) < 256 && Number(RegExp.$4) < 256) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

// 对象转换为form表单：
export function toFormData (params) {
    const formData = new FormData()
    for (const key in params) {
      formData.append(key, params[key])
    }
    return formData
}

/**
 * @method 找到树里面的某一项
 * @param
 * @return
 */
export const findItemForTree = (data, childrenName, propertyName, propertyValue) => {
    let itemRes = {}
    const find = (tree, children, key, value) => {
      tree.some(item => {
        if (item[key] == value) {
          itemRes = item
          return true
        } else if (item[children] && item[children].length > 0) {
          find(item[children], children, key, value)
        }
      })
    }
    find(data, childrenName, propertyName, propertyValue)
    return itemRes
}

export const getBroswer = () => {
    const ua = navigator.userAgent
    const os = (/\s\((.*?);/.exec(ua) || [])[1]
    const browser = {}
    const firefox = ua.match(/Firefox\/([\d.]+)/)
    const ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/)
    const edge = ua.match(/Edge\/([\d.]+)/) // IE 12 and 12+
    const chrome = ua.match(/Chrome\/([\d.]+)/)
    const safari = !chrome ? ua.match(/Safari\/([\d.]+)/) : false
    const weChat = /micromessenger/i.test(ua)
    if (firefox) {
      browser.firefox = true
      browser.version = firefox[1]
    }
    if (ie) {
      browser.ie = true
      browser.version = ie[1]
    }
    if (edge) {
      browser.edge = true
      browser.version = edge[1]
    }
    if (chrome) {
      browser.chrome = true
      browser.version = chrome[1]
    }
    if (safari) {
      browser.safari = true
      browser.version = safari[1]
    }
    if (weChat) {
      browser.weChat = true
    }
    return {
      browser: browser,
      os: os
    }
}

/**
 * 格式化时间
 */

export const formatDate = (time, formatString) => {
    if (!time) return ''
    return dayjs(time).format(formatString)
}
// 小于10000原样展示，大于等于10000展示万，保留2位小数点
export function formateNum({ num, step = 1, stepLabel = '', labelStyle = '' }) {
    if (typeof num !== 'number') return '--'
    if (num < step) return num
    return Number.parseFloat((num/step).toFixed(2)) + `<span style="${labelStyle}">${stepLabel}</span>`
}

// 文件大小转换
export function converByte(bytes) {
    if (!bytes || !Number(bytes)) return '0B'
    var k = 1024,
    //   sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    //   sizes = ['GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      sizes = ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k))
    var num = bytes / Math.pow(k, i)
    if (num > 1000) {
      return (num / 1024).toPrecision(2) + sizes[i + 1]
    } else {
      return num.toPrecision(3) + sizes[i]
    }
}

// 服务端接口返回值统一处理
export function checkRes(obj) {
  const { res, success, failed } = obj
  const { code = res.status, msg } = res
  console.log(msg)
  const rt = res.rt || {}
  switch (Number(code)) {
    case 200:
      if (rt.resultStatus === 1) {
        success && success(rt)
      } else if (rt.resultStatus === undefined) {
        success && success({ resultStatus: 888, rt }) // 接口正常返回结果中没有resultStatus，前端自定义resultStatus:888
      } else {
        failed && failed(res)
      }
      break;
    case 999: // 前端默认出错处理
      failed && failed(rt)
      break;
    default:
      failed && failed(res)
      break;
  }
}

// 时间戳转化为年月日时分秒
export const timestampToDate = timestamp => {
	const date = new Date(timestamp)
	const year = date.getFullYear()
	const month = (date.getMonth() + 1).toString().padStart(2, '0')
	const day = date.getDate().toString().padStart(2, '0')
	const hour = date.getHours().toString().padStart(2, '0')
	const minute = date.getMinutes().toString().padStart(2, '0')
	const sechond = date.getSeconds().toString().padStart(2, '0')
	return `${year}-${month}-${day} ${hour}:${minute}:${sechond}`
}

// 通过时间戳获取周几：
export const timestampToWeekDay = timestamp => {
  const cnWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  const date = new Date(timestamp)
  const weekDay = date.getDay()
  return cnWeek[weekDay]
}

export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}